import React from 'react'
import { Container } from 'react-bootstrap'
import ReservationRestrictions from '../../components/reservation-restrictions/ReservationRestrictionsContainer'

const ReservationRestrictionsPage = () => {
  return (
    <Container>
      <ReservationRestrictions />
    </Container>
  )
}

export default ReservationRestrictionsPage
